// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BriefRow-module__row___PwUOT {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #e4e4e7;
}

.BriefRow-module__label___VcaoE {
  margin: 0;
  padding: 8px 12px;
  font-size: 16px;
  font-weight: 700;
  color: #18181b;
  background: #f4f4f5;
  border-left: 4px solid #18181b;
  border-radius: 6px;
}

.BriefRow-module__labelAlert___GF3dh {
  color: #991b1b;
  background: #fef2f2;
  border-left-color: #991b1b;
}

.BriefRow-module__content___P4tQH {
  min-width: 0;
}

@container (max-width: 639px) {
  .BriefRow-module__row___PwUOT {
    gap: 8px;
    padding: 12px 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/BriefRow.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,0BAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE;IACE,QAAA;IACA,kBAAA;EACF;AACF","sourcesContent":[".row {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #e4e4e7;\n}\n\n.label {\n  margin: 0;\n  padding: 8px 12px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #18181b;\n  background: #f4f4f5;\n  border-left: 4px solid #18181b;\n  border-radius: 6px;\n}\n\n.labelAlert {\n  color: #991b1b;\n  background: #fef2f2;\n  border-left-color: #991b1b;\n}\n\n.content {\n  min-width: 0;\n}\n\n@container (max-width: 639px) {\n  .row {\n    gap: 8px;\n    padding: 12px 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `BriefRow-module__row___PwUOT`,
	"label": `BriefRow-module__label___VcaoE`,
	"labelAlert": `BriefRow-module__labelAlert___GF3dh`,
	"content": `BriefRow-module__content___P4tQH`
};
module.exports = ___CSS_LOADER_EXPORT___;
